import { ReactElement } from "react";
import { Avatar } from "@twilio-paste/core/avatar";
import { Box } from "@twilio-paste/core/box";
import {
  MediaObject,
  MediaFigure,
  MediaBody,
} from "@twilio-paste/core/media-object";
import { ArtificialIntelligenceIcon } from "@twilio-paste/icons/esm/ArtificialIntelligenceIcon";
import { Stack } from "@twilio-paste/core/stack";

import { useWiseOwlContext } from "../../../../hooks";
import { MessageSkeletonLoader } from "../../../../components/blockRenderer/sub";
import { constants as blockRendererConstants } from "../../../../components/blockRenderer/definitions";

const FetchChatLoader = (): ReactElement => {
  const { author } = useWiseOwlContext();

  return (
    <Stack orientation="vertical" spacing="space40">
      <MediaObject verticalAlign="top">
        <MediaFigure spacing="space50">
          <Box paddingTop="space40">
            <Avatar size="sizeIcon50" name={author} color="decorative20" />
          </Box>
        </MediaFigure>

        <MediaBody>
          <MessageSkeletonLoader />
        </MediaBody>
      </MediaObject>

      <MediaObject verticalAlign="top">
        <MediaFigure spacing="space50">
          <Box paddingTop="space40">
            <Avatar
              size="sizeIcon50"
              name={blockRendererConstants.MESSAGE_AI_NAME}
              icon={ArtificialIntelligenceIcon}
              color="decorative40"
            />
          </Box>
        </MediaFigure>

        <MediaBody>
          <MessageSkeletonLoader />
        </MediaBody>
      </MediaObject>
    </Stack>
  );
};

export default FetchChatLoader;
